import { RemittanceDataTy } from '../../Remittances/ModalNewRemittance/types';

export const getSelectedIdsRemittanceMarkAsPaid = (completeData: RemittanceDataTy) => {
    const result: number[] = []
    if (completeData?.selectedTableData){
        for (const element of completeData.selectedTableData) {
            const parsedId = parseInt(String(element.id))
            result.push(parsedId)
        }
    }
    return result
}